module.exports = __webpack_public_path__ + "assets/walkme.4e8769ee.svg";